export const JOB_API = `v1/jobs`;
